import { render } from "./PageAchievement.vue?vue&type=template&id=5c14ab7a&scoped=true"
import script from "./PageAchievement.vue?vue&type=script&lang=js"
export * from "./PageAchievement.vue?vue&type=script&lang=js"

import "./PageAchievement.vue?vue&type=style&index=0&id=5c14ab7a&scoped=true&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c14ab7a"]])

export default __exports__